import {reducer as toastrReducer} from 'react-redux-toastr'
import auth from './auth'
import visits from './visits'
import locations from './locations'
import verification from './verification'

const moonlightReducer = (state = {}, action: Action) => {
  return {
    auth: auth(state.auth, action),
    toastr: toastrReducer(state.toastrReducer, action),
    visits: visits(state.visits, action),
    locations: locations(state.locations, action),
    verification: verification(state.verification, action),
  }
}

export default moonlightReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js